interface Props {
	status: 'done' | 'active' | 'pending'
	label: string
	description: string
	value: string
	color: 'primary' | 'secondary'
}

const StepperItem: React.FC<Props> = ({ label, value, description, status, color }) => {
	const doneImg =
		color === 'primary'
			? '/media/stepper/purple-check-stepper-icon.svg'
			: '/media/stepper/check-stepper-icon.svg'
	const activeImg =
		color === 'primary'
			? '/media/stepper/purple-active-stepper-icon.svg'
			: '/media/stepper/active-stepper-icon.svg'
	const pendingImg = '/media/stepper/pending-stepper-icon.svg'

	const img = status === 'done' ? doneImg : status === 'active' ? activeImg : pendingImg

	return (
		<div className={`kumopack-stepper-item ${status}`}>
			<img
				src={img}
				alt="Step Icon Base Blue"
				width={32}
				height={32}
				style={{ userSelect: 'none', pointerEvents: 'none' }}
			/>
			<div className="label fw-bold text-kumopack-grey-700">{label}</div>
			<div className="date text-kumopack-grey-600 fs-8">{description}</div>
		</div>
	)
}

export default StepperItem
